import React from 'react';
import './index.scss';

const PatentNotice = () => (
    <div className='patent-notice-wrapper'>
        <div className='patent-notice-head'>
            <div className='patent-notice-head__left'>
                <h1 className='patent-notice-head__title'>Patent Notice</h1>
            </div>
        </div>
        <div className='patent-notice-content'>
            <div className='patent-notice-content__desc'>
                <p>
                    The Klickly platform incorporates proprietary technologies that are protected under one or more U.S.
                    patents. In particular, certain methods and systems used for digital commerce, real-time
                    transactional ad units, and in-ad checkout experiences are covered by U.S. Patent No. 12,307,479,
                    titled “Method and Apparatus for Digital Commerce.”
                </p>
            </div>
            <div className='patent-notice-content__desc'>
                <p>
                    This patent covers innovations related to the seamless facilitation of purchases within distributed
                    digital environments, including the ability to dynamically serve, track, and complete e-commerce
                    transactions without redirecting users to external storefronts.
                </p>
            </div>
            <div className='patent-notice-content__desc'>
                <p>
                    We take the protection of our intellectual property seriously. Unauthorized use, reproduction, or
                    deployment of technologies protected under this patent is strictly prohibited and may be subject to
                    legal enforcement.
                </p>
            </div>
            <div className='patent-notice-content__desc'>
                <p>Additional patents may be pending in the United States and other jurisdictions.</p>
            </div>
        </div>
    </div>
);
export default PatentNotice;
